import { batch } from 'react-redux';
import { Action } from 'redux';
import { FILTERS_SELECT_ALL_OFFER_TYPES_TYPE } from '../../constants/action_types';
import { TThunkAction } from '../../types/redux';
import { getMeta } from './getMeta';

export type TSelectAllOfferTypesType = 'filters/select_all_offer_types';

export interface ISelectAllOfferTypes extends Action<TSelectAllOfferTypesType> {
  type: TSelectAllOfferTypesType;
}

export type TSelectAllOfferTypes = ISelectAllOfferTypes;

export function selectAllOfferTypes(): TThunkAction {
  return dispatch => {
    batch(() => {
      dispatch<TSelectAllOfferTypes>({
        type: FILTERS_SELECT_ALL_OFFER_TYPES_TYPE,
      });

      dispatch(getMeta());
    });
  };
}
